function isOnScreen(elem) {
	// if the element doesn't exist, abort
	if( elem.length == 0 ) {
		return;
	}
	var $window = jQuery(window)
	var viewport_top = $window.scrollTop()
	var viewport_height = $window.height()
	var viewport_bottom = viewport_top + viewport_height
	var $elem = jQuery(elem)
	var top = $elem.offset().top
	var height = $elem.height()
	var bottom = top + height

	return (top >= viewport_top && top < viewport_bottom) ||
	(bottom > viewport_top && bottom <= viewport_bottom) ||
	(height > viewport_height && top <= viewport_top && bottom >= viewport_bottom)
}
$(document).ready(function() {

    $(window).on('scroll',function(){
      if($(window).scrollTop() > 750 && $(window).width() > 1070) {
        $(".desktop-sticky-head").fadeIn(100);
      } else if(isOnScreen($(".supplement_sec"))) {
        $(".desktop-sticky-head").fadeOut(100);
      } else {
        $(".desktop-sticky-head").fadeOut(100);
      }      
    });

    window.setTimeout(function(){
        $.get("/cart/clear",function(){});
    },1000)

    $(document).on('click','.add-to-cart-button-final',function(e){
        e.preventDefault();
        var variant_id = $(e.target).attr('data-variantid');
        var qty = $(e.target).attr('data-qty');
        var discount_code = $(e.target).attr('data-dc');
        if($(e.target).hasClass('add-to-cart-button-final')) {
          variant_id = $(e.target).attr('data-variantid');
          qty = $(e.target).attr('data-qty');
          discount_code = $(e.target).attr('data-dc');
        } else {
          variant_id = $(e.target).parents('.add-to-cart-button-final').eq(0).attr('data-variantid');
          qty = $(e.target).parents('.add-to-cart-button-final').eq(0).attr('data-qty');
          discount_code = $(e.target).parents('.add-to-cart-button-final').eq(0).attr('data-dc');        
        }        
        $.ajax({
            url : "/cart/add.js",
            data : { id: variant_id , quantity : qty },
            method : "POST",
            dataType : "JSON",
            success : function(data) {
                window.location = "/checkout?discount="+discount_code;
            },
            error : function(data) {
                window.alert('Error');
            }
        });
    });

  $(document).on('click','.scrollToButton',function(e){
    e.preventDefault();
    var new_position = jQuery(".supplement_sec").offset();
    var scroll = 100;
    jQuery('html, body').stop().animate({ scrollTop: new_position.top + scroll }, 800, function(){
      var new_position = jQuery(".supplement_sec").offset();
      if($(window).width() < 768) {
        scroll = 350;
      }
        jQuery('html, body').stop().animate({ scrollTop: new_position.top + scroll }, 500);
    });
    e.preventDefault();
  });

  $(document).on('click','.scrollToButtonWhatMakes',function(e){
    e.preventDefault();
    var new_position = jQuery(".quality_sec").offset();
    var scroll = -50;
    jQuery('html, body').stop().animate({ scrollTop: new_position.top + scroll }, 800, function(){
      var new_position = jQuery(".quality_sec").offset();
      if($(window).width() < 768) {
        scroll = -50;
      }
        jQuery('html, body').stop().animate({ scrollTop: new_position.top + scroll }, 500);
    });
    e.preventDefault();
  });


  $(document).ready(function(){

    if( isOnScreen($(".video_wrapper")) && $(".video_wrapper").find('iframe').attr('src') == "") {
        var src_val = $(".video_wrapper").find('iframe').attr('data-src');
        $(".video_wrapper").find('iframe').attr('src',src_val);
    }
    
    if( isOnScreen($(".non-sticky-atc-button").eq(0)) ||
    isOnScreen($(".non-sticky-atc-button").eq(1)) || 
    isOnScreen($(".non-sticky-atc-button").eq(2)) || 
    isOnScreen($(".non-sticky-atc-button").eq(3)) ||
    isOnScreen($(".non-sticky-atc-button").eq(4)) ||
    isOnScreen($(".non-sticky-atc-button").eq(5)) || 
    isOnScreen($(".non-sticky-atc-button").eq(6)) || 
    isOnScreen($(".non-sticky-atc-button").eq(7)) ||
    isOnScreen($(".non-sticky-atc-button").eq(8))) {
             $(".sticky-atc-button").fadeOut(10);
            } else {
            $(".sticky-atc-button").fadeIn(10);
            }
    
    $(window).on('scroll',function(){

    if( isOnScreen($(".video_wrapper")) && $(".video_wrapper").find('iframe').attr('src') == "") {
        var src_val = $(".video_wrapper").find('iframe').attr('data-src');
        $(".video_wrapper").find('iframe').attr('src',src_val);
    }
    if( isOnScreen($(".non-sticky-atc-button").eq(0)) ||
        isOnScreen($(".non-sticky-atc-button").eq(1)) || 
        isOnScreen($(".non-sticky-atc-button").eq(2)) ||
        isOnScreen($(".non-sticky-atc-button").eq(3)) ||
        isOnScreen($(".non-sticky-atc-button").eq(4)) ||
        isOnScreen($(".non-sticky-atc-button").eq(5)) || 
        isOnScreen($(".non-sticky-atc-button").eq(6)) || 
        isOnScreen($(".non-sticky-atc-button").eq(7)) ||
        isOnScreen($(".non-sticky-atc-button").eq(8))) {
        $(".sticky-atc-button").fadeOut(10);
        } else {
            $(".sticky-atc-button").fadeIn(10);
        }
    });	
});	
$('.testimonial_slider').slick({
    centerMode: true,
  	centerPadding: 0,
  	slidesToShow: 3,
  	slidesToScroll: 1,
    focusOnSelect: true,  
    infinite: true,
    dots:false,
    arrows:true,
    autoplay:false,
    prevArrow: '<button class="slick-prev slick-arrow"><span class="material-icons">chevron_left</span></button>',
    nextArrow: '<button class="slick-next slick-arrow"><span class="material-icons">chevron_right</span></button>',
    responsive: [
      {
        breakpoint: 991,
        settings: {
          slidesToShow:1,
          slidesToScroll: 1,
        }
      },
        {
          breakpoint: 767,
          settings: {
            slidesToShow:1,
            slidesToScroll: 1,
          }
        },
        ,
        {
          breakpoint: 575,
          settings: {
            slidesToShow:1,
            slidesToScroll: 1,
          }
        },
    ]
});
// Image Slider  
$('.img-slider').slick({ 
  	slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,  
    infinite: true,
    dots:true,
    arrows:false,
    responsive: [
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          autoplay: true,
          autoplaySpeed: 2000,  
          infinite: true,
          dots:true,
          arrows:false,
        }
      },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 2000,  
            infinite: true,
            dots:true,
            arrows:false,
          }
        },
        ,
        {
          breakpoint: 575,
          settings: {
      		slidesToShow: 1,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 2000,  
            infinite: true,
            dots:true,
            arrows:false,
          }
        },
    ]
});
  
  

 //accordion js
    // Add minus icon for collapse element which is open by default
  $(".collapse.show").each(function(){
      $(this).prev(".card-header").find(".fas").addClass("fa-opened").removeClass("fa-closed");
  });
  
  // Toggle plus minus icon on show hide of collapse element
  $(".collapse").on('show.bs.collapse', function(){
      $(this).prev(".card-header").find(".fas").removeClass("fa-closed").addClass("fa-opened");
  }).on('hide.bs.collapse', function(){
      $(this).prev(".card-header").find(".fas").removeClass("fa-opened").addClass("fa-closed");
  });
});
